import CloseIcon from '@mui/icons-material/Close';
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type Props = {
  open: boolean;
  position?: 'left' | 'right';
  onClose: () => void;
  minWidth?: number | string;
  children: ReactNode;
  title?: string;
  subTitle?: string;
  description?: string;
};

const DrawerPanel = ({
  open,
  position = 'right',
  onClose,
  minWidth = '40vw',
  children,
  title,
  subTitle,
  description,
}: Props) => {
  const subtitleText = subTitle || description;
  return (
    <Drawer
      open={open}
      anchor={position}
      hideBackdrop={true}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            height: '100vh',
            // top: 69,
            width: minWidth,
            minWidth,
            maxWidth: '50vw',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: 'none',
            borderLeft: position === 'right' ? 1 : 0,
            borderRight: position === 'left' ? 1 : 0,
            borderColor: 'divider',
          },
        },
      }}
    >
      {(title || subtitleText) && (
        <Box
          sx={{
            py: 1,
            px: 2,
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: 'background.paper',
          }}
        >
          <Stack>
            {title && (
              <Typography variant="subtitle1" fontWeight="bold">
                {title}
              </Typography>
            )}
            {subtitleText && (
              <Typography variant="caption" color="text.secondary">
                {subtitleText}
              </Typography>
            )}
          </Stack>
          <IconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
      <Box sx={{ flexGrow: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>{children}</Box>
    </Drawer>
  );
};

export default DrawerPanel;
